module.exports = __webpack_public_path__ + "img/reinvite.6fd7b188.png";